const $ = window.$;

function createDialog(color='success') {
  const divDialog = document.createElement('div');

  divDialog.className = `modal`;
  divDialog.setAttribute('role', 'dialog');
  divDialog.setAttribute('id', 'dlg-wait');
  divDialog.style.textAlign = 'center';
  // divDialog.style.position = 'absolute';
  // divDialog.style.top = 'calc(100%/2)';
  divDialog.innerHTML = `<div 
  class="spinner-border 
  text-${color}" 
  role="status"
  style="width: 5rem; height: 5rem; position: absolute; top: calc(100%*0.3);">
    <span class="sr-only">Loading...</span>
  </div>`;

  return divDialog;
}

export function showWaiting(color='success') {
  const divDialog = createDialog(color);

  let sectionWait = document.getElementById('section-wait');
  if (!sectionWait) {
    const divSectionWait = document.createElement('div');
    divSectionWait.id = 'section-wait';
    document.body.append(divSectionWait);

    sectionWait = document.getElementById('section-wait');
  }

  sectionWait.appendChild(divDialog);

  $('#dlg-wait').modal({
    keyboard: false,
  });
}

export function hideWaiting() {
  const divDialog = document.getElementById('dlg-wait');
  if (!divDialog) return;

  $('#dlg-wait').modal('hide').modal('dispose');
  divDialog.remove();
}